var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _rect3, _rect4, _path6, _rect5, _rect6, _path7, _rect7, _rect8, _path8, _rect9, _rect0, _path9, _rect1, _rect10, _path0, _rect11, _rect12, _path1, _rect13, _rect14, _path10, _rect15, _rect16, _path11, _rect17, _rect18, _path12, _rect19, _rect20, _path13, _rect21, _rect22, _path14, _rect23, _rect24, _path15, _rect25, _rect26, _rect27, _rect28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExteriorFrontOverlay = function SvgExteriorFrontOverlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 724 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-leftFrontFender-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M535.705 225.773H531.303L538.151 230.176L544.022 232.133C546.761 232.524 557.556 239.145 562.611 242.406C582.57 253.755 604.518 272.899 612.997 281.052C629.434 297.88 640.718 315.784 644.305 322.633C645.479 325.372 645.773 328.34 645.773 329.482C652.035 324.394 657.84 316.6 659.959 313.338V307.468C659.959 304.729 657.35 301.109 656.046 299.641C653.307 294.553 639.25 279.584 632.565 272.736C618.868 257.082 591.636 245.993 579.732 242.406C578.167 241.623 564.405 238.492 557.719 237.025C556.154 237.025 547.609 233.111 543.532 231.155C540.793 229.98 537.173 227.078 535.705 225.773Z",
    fill: "#FFA928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-backBumper-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M47.4946 251.7L43.5811 217.457L54.8324 236.535C51.8973 241.427 52.7126 250.885 53.3648 256.103C52.8756 257.081 51.8973 262.299 51.4081 265.398C51.0167 265.006 48.9621 256.755 47.9838 252.679L47.4946 251.7Z",
    fill: "#FFA928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-rightBackLight-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M53.3649 146.037C52.3865 143.591 54.9955 138.21 56.7892 135.764C54.4411 138.112 52.2234 141.96 51.4081 143.591C50.4298 147.015 50.9189 150.929 51.4081 152.885C52.9735 157.19 54.6694 156.799 55.3216 155.82C56.1043 154.646 55.6477 151.581 55.3216 150.439L53.3649 146.037Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightFrontWheel"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-rightFrontWheel-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M314.592 441.017C313.027 412.839 326.333 402.371 328.289 401.881L331.714 399.925C339.541 395.228 349.324 392.75 353.238 392.098C363.022 395.62 375.904 413.133 381.122 421.449C389.732 434.755 398.243 458.138 400.689 470.368C401.472 471.542 403.624 492.055 404.603 502.165L405.581 506.079L405.092 507.546L407.049 509.014C407.049 509.797 405.418 511.297 404.603 511.949L381.611 521.733C372.61 524.864 363.185 521.407 359.597 519.287C345.509 511.851 334.16 496.947 330.246 490.425C316.549 465.965 315.57 451.29 314.592 441.017Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightFrontWheel-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 337.562,
    y: 438.551,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 354.5,
    y: 460.6,
    id: "exterior-front-rightFrontWheel-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 337.562,
    y: 438.551,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightFrontDoor"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-rightFrontDoor-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.067 415.579L182.021 344.646V337.308C184.304 332.417 188.283 321.948 185.935 319.208C184.956 318.067 183 315.099 183 312.36C182.021 299.804 181.141 270.877 185.446 255.614L185.935 253.168C186.913 249.254 189.457 240.742 191.805 238.003C192.783 236.046 194.642 231.35 194.251 228.219L194.74 223.817C194.414 223.49 193.86 222.545 194.251 221.371C194.414 220.881 194.936 219.903 195.719 219.903C200.121 197.726 210.394 153.862 211.373 151.417C211.21 150.438 211.275 148.384 212.84 147.992C226.048 154.352 249.04 169.517 261.27 183.214C270.075 192.019 292.578 221.371 309.7 287.411C310.189 289.531 311.069 293.868 310.678 294.26C310.678 296.706 310.515 301.353 304.808 309.914C303.981 311.155 303.189 312.133 302.448 313.051C299.777 316.356 297.746 318.867 296.981 329.971C296.981 329.971 293.556 381.825 293.067 415.579ZM266.162 290.347C272.032 286.922 281.781 282.8 285.24 282.031C289.169 281.159 291.312 282.721 292.423 283.53C292.557 283.628 292.675 283.714 292.781 283.784L297.183 287.698C298.488 288.676 301.293 290.731 302.075 291.122C303.706 292.101 306.38 294.742 304.032 297.482C303.869 297.645 303.347 297.971 302.564 297.971H301.097C298.977 298.786 294.346 300.515 292.781 300.906C286.258 302.863 274.681 305.798 268.321 306.776C265.875 307.265 259.809 307.657 257.07 305.309C256.581 304.983 255.908 303.951 256.378 301.598C256.965 298.663 259.509 293.869 266.162 290.347Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightFrontDoor-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 214.286,
    y: 278.094,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 231.2,
    y: 300.185,
    id: "exterior-front-rightFrontDoor-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 214.286,
    y: 278.094,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightFrontFender"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-rightFrontFender-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M305.787 424.388L293.068 415.582C293.557 386.72 295.514 337.801 298.449 320.19C298.724 318.541 301.71 313.994 303.341 311.874C305.16 309.509 307.58 305.841 308.722 303.558C309.7 302.09 311.168 296.709 310.678 291.328L336.116 294.263L331.224 307.471C332.007 310.211 338.399 313.505 341.497 314.809L401.668 343.671C408.321 346.019 438.357 362.913 452.543 371.066C454.109 371.457 472.763 382.97 481.895 388.677C485.808 391.416 486.134 394.384 485.808 395.525C479.155 397.091 456.946 399.765 446.673 400.907C440.803 401.298 433.465 400.091 430.53 399.439C429.356 399.439 427.105 400.417 426.127 400.907L390.416 419.007L383.568 425.366C373.295 405.798 356.662 392.101 344.432 387.209C339.051 384.763 322.72 382.807 314.592 394.547C305.787 407.266 305.297 417.539 305.787 424.388Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightFrontFender-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 337.562,
    y: 343.648,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 354.5,
    y: 365.739,
    id: "exterior-front-rightFrontFender-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 337.562,
    y: 343.648,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-frontWindow"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-frontWindow-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M294.536 189.41C294.536 187.453 297.471 185.985 299.428 185.495C323.888 177.18 392.374 156.143 435.912 143.424C441.782 142.446 443.739 143.912 445.696 144.892C458.904 154.674 497.549 192.02 519.073 217.458C522.496 222.348 520.054 223.815 517.609 225.283L517.605 225.285C481.405 244.853 397.754 271.758 354.217 282.843C349.13 284.409 343.944 284.8 341.988 284.8C337.683 284.409 335.801 281.542 334.159 277.139C323.397 248.277 305.299 211.096 296.004 194.789C294.439 191.658 294.536 191.856 294.536 189.41Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-frontWindow-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 388.438,
    y: 191.02,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 405.3,
    y: 213.11,
    id: "exterior-front-frontWindow-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 388.438,
    y: 191.02,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-frontHood"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-frontHood-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M332.203 304.535C332.594 304.144 334.975 297.85 336.116 294.752C336.116 292.013 356.988 286.598 367.424 283.988C402.646 275.672 468.686 252.191 502.93 237.515C504.495 236.732 520.214 229.689 527.878 226.265C529.052 225.483 530.65 225.613 531.303 225.776L538.151 230.179C544.022 231.645 545.33 232.438 548.424 234.091C591.473 257.083 620.335 286.923 632.076 303.067C634.032 305.512 641.044 316.764 644.305 322.634C645.773 326.058 645.773 327.526 645.773 329.483C644.99 330.657 633.543 341.223 626.695 346.117C616.422 353.453 586.581 366.661 568.97 373.51C552.589 379.88 532.77 386.229 523.965 388.187L486.297 395.523C485.808 390.142 478.47 385.904 475.046 384.273C461.349 374.488 402.157 342.691 356.173 321.656C353.042 320.482 333.181 311.383 332.203 308.938C331.029 308.156 331.714 305.677 332.203 304.535Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-frontHood-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 492.146,
    y: 283.966,
    width: 33.3081,
    height: 33.3081,
    rx: 16.6541,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 508.7,
    y: 305.712,
    id: "exterior-front-frontHood-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 492.146,
    y: 283.966,
    width: 33.3081,
    height: 33.3081,
    rx: 16.6541,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-frontBumper"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-frontBumper-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M390.416 419.005L383.568 425.364C400.689 454.716 403.135 482.11 404.114 495.807L404.603 502.167L405.092 502.656C405.092 503.145 405.581 505.428 405.581 506.08C405.19 506.863 405.418 507.385 405.581 507.548L412.919 512.44C418.398 515.962 434.443 520.756 441.781 522.713C450 524.278 460.86 523.039 465.262 522.224C467.61 521.832 490.374 514.886 501.462 511.461C503.81 510.679 513.529 509.179 518.095 508.526C524.356 507.744 543.859 500.21 552.827 496.297C581.689 483.578 629.141 460.586 637.457 453.248C637.457 453.248 644.591 447.639 646.751 445.91C651.643 441.997 655.394 439.388 658.003 437.594C669.743 430.256 673.168 426.669 674.146 424.875C675.32 422.918 674.961 419.168 674.635 417.537C677.375 415.972 680.016 409.384 680.995 406.286L689.311 362.259C689.702 358.737 688.496 356.878 687.843 356.388C668.276 337.212 661.101 319.699 659.96 313.34C660.351 327.428 659.144 332.255 658.492 332.907C655.752 341.908 642.186 351.334 635.989 354.921L637.946 336.821C625.716 353.943 540.108 388.186 502.441 392.588L510.268 407.753C500.092 411.276 486.787 413.624 481.405 414.113C469.665 415.58 458.471 415.457 452.054 413.624C441.781 410.688 434.117 403.025 430.53 399.437C428.573 399.437 421.887 403.025 418.789 404.818L390.416 419.005Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-frontBumper-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 573.351,
    y: 422.898,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    x: 590.25,
    y: 444.989,
    textAnchor: "middle",
    id: "exterior-front-frontBumper-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 573.351,
    y: 422.898,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightFrontLight"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-rightFrontLight-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M447.162 411.668C441.683 409.711 433.791 402.699 430.53 399.438C438.748 402.177 457.435 400.253 465.751 398.949C472.013 398.166 492.494 394.383 501.951 392.589L510.268 407.754C498.918 412.059 479.449 414.44 471.132 415.092C459.001 415.875 450.097 413.135 447.162 411.668Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightFrontLight-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 460.838,
    y: 387.676,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 477.75,
    y: 409.767,
    id: "exterior-front-rightFrontLight-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 460.838,
    y: 387.676,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightMirror"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-rightMirror-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M285.24 282.034C281.781 282.802 272.032 286.925 266.162 290.349C259.509 293.871 256.965 298.665 256.378 301.6C255.908 303.954 256.581 304.985 257.07 305.311C259.81 307.659 265.875 307.268 268.321 306.779C274.681 305.8 286.258 302.865 292.781 300.909C294.346 300.517 298.977 298.789 301.097 297.973H302.565C303.347 297.973 303.869 297.647 304.032 297.484C306.38 294.745 303.706 292.103 302.075 291.125C301.293 290.733 298.488 288.679 297.184 287.7L292.781 283.787C291.803 283.135 289.643 281.057 285.24 282.034Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightMirror-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 264.184,
    y: 278.098,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 281.05,
    y: 300.189,
    id: "exterior-front-rightMirror-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 264.184,
    y: 278.098,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-leftMirror"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-leftMirror-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M523.476 203.761L520.541 209.142L528.857 218.435C532.379 218.044 541.413 213.706 545.489 211.586C549.892 209.14 550.707 207.999 550.87 207.184C551.359 205.227 550.762 202.637 549.403 200.824C547.055 197.693 544.022 196.912 542.554 196.912C538.641 196.521 532.118 198.054 529.346 198.869C525.922 200.335 524.454 202.294 523.476 203.761Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-leftMirror-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 523.454,
    y: 187.105,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 540.2,
    y: 209.196,
    id: "exterior-front-leftMirror-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 523.454,
    y: 187.105,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-leftFrontLight"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-leftFrontLight-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M636.479 354.432L638.435 336.332C653.6 323.124 658.981 315.46 659.96 313.34V326.548C659.568 332.418 656.535 337.799 654.089 340.245C649.002 346.898 640.229 352.475 636.479 354.432Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-leftFrontLight-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 635.968,
    y: 315.275,
    width: 33.3081,
    height: 33.3081,
    rx: 16.6541,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 652.4,
    y: 337.02,
    id: "exterior-front-leftFrontLight-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 635.968,
    y: 315.275,
    width: 33.3081,
    height: 33.3081,
    rx: 16.6541,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-roof"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-roof-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M440.314 137.229C431.312 136.838 334.486 168.048 287.197 183.702C287.034 183.376 286.512 182.627 285.73 182.236C284.947 181.844 279.859 176.528 277.414 173.919C269.587 163.744 248.714 150.764 239.257 145.546C209.416 127.446 166.205 112.934 146.311 108.368C137.016 105.433 126.906 107.716 121.851 108.857C121.46 108.075 124.95 104.944 126.743 103.476L127.722 100.541C140.245 90.3659 162.454 83.8108 174.195 79.9951C193.762 73.6357 219.037 69.7221 229.962 69.233C238.768 68.7438 252.628 68.743 258.824 69.2318C265.477 66.4923 281.49 67.7642 288.665 68.7426C318.799 72.6561 360.902 88.9624 378.187 96.6264C406.364 108.758 421.235 119.292 425.149 123.043C431.802 126.956 438.031 134.131 440.314 137.229Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-roof-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 269.076,
    y: 93.1816,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 285.85,
    y: 115.273,
    id: "exterior-front-roof-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 269.076,
    y: 93.1816,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightRearDoor"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-rightRearDoor-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M212.351 147.995C198.263 140.168 168.65 129.732 155.605 125.492C153.649 125.884 153.159 127.286 153.159 127.938C147.289 130.678 127.232 153.865 117.938 165.117C115.981 165.508 115.818 166.91 115.981 167.562C114.84 169.519 112.459 173.531 112.068 173.922C111.676 175.487 107.991 178.488 106.197 179.792C102.284 182.14 100.327 185.01 99.8378 186.152C97.881 187.717 91.5216 218.112 88.5864 233.114C103.751 253.171 115.003 286.925 116.959 303.068C117.742 302.285 122.177 305.025 124.297 306.492L182.022 344.649V337.311C183.978 333.789 185.772 327.69 186.424 325.081C186.913 320.189 186.261 319.7 185.935 319.211C183.978 316.863 183.226 314.471 183 313.341C182.511 310.895 182.185 295.893 182.022 288.881C182.413 267.748 185.12 254.964 186.424 251.214C186.816 248.083 189.849 241.43 191.316 238.495C192.099 237.712 193.273 234.581 193.762 233.114C194.545 231.157 194.251 227.244 194.74 223.819C193.273 221.373 194.904 220.069 195.719 219.906C200.024 197.207 207.949 164.79 211.373 151.419C210.982 150.245 211.862 148.647 212.351 147.995Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightRearDoor-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 123.297,
    y: 218.418,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    id: "exterior-front-rightRearDoor-text",
    x: 140.25,
    y: 240.509,
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 123.297,
    y: 218.418,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightRearFender"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-rightRearFender-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M99.8376 185.662C98.6636 185.271 91.8475 216.807 88.5863 232.624L86.1403 241.43C79.4873 233.603 72.9323 230.342 70.4863 229.689C66.1815 228.515 63.1485 229.2 62.1701 229.689C57.2782 231.646 56.2998 234.092 54.8323 236.538L43.5809 217.46L42.6025 203.273L44.5593 198.871C46.9074 192.609 48.4728 184.521 48.962 181.26L52.3863 155.822C53.9517 156.605 54.9953 156.148 55.3215 155.822C56.8869 153.474 54.9953 148.973 53.8538 147.017C51.5057 143.494 55.4845 137.722 57.7673 135.276C60.5068 130.971 68.0403 126.96 71.4646 125.492L102.284 145.06C99.9355 150.539 110.437 162.344 115.981 167.562C113.633 172.65 110.437 176.205 109.132 177.346C105.219 180.086 101.305 184.032 99.8376 185.662Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightRearFender-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 52.854,
    y: 172.434,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 69.65,
    y: 194.525,
    id: "exterior-front-rightRearFender-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 52.854,
    y: 172.434,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightBackWheel"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "exterior-front-rightBackWheel-overlay",
    className: "svg-exterior-overlay",
    opacity: 0,
    d: "M52.8756 258.061C56.3721 247.072 61.681 243.874 65.1054 242.896L82.227 238.004H82.7162C84.6729 239.569 89.7279 246.483 92.0108 249.744C99.0551 257.571 107.665 287.575 111.089 301.599L114.024 311.871L119.895 325.569L127.722 330.461L134.57 335.353C134.57 336.135 133.918 337.146 133.592 337.309L104.241 347.582C99.5443 349.539 95.4351 349.702 93.9675 349.539C87.7059 349.148 81.2486 344.484 78.8027 342.201C72.541 337.114 65.7576 326.058 63.1486 321.166C56.4956 309.817 52.8756 293.935 51.8972 287.412C49.9405 272.541 51.7342 261.648 52.8756 258.061Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-rightBackWheel-point",
    className: "svg-exterior-point",
    opacity: 0
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5946,
    y: 277.117,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    x: 81.45,
    y: 299.208,
    id: "exterior-front-rightBackWheel-text",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "\n      0\n      "), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5946,
    y: 277.117,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-other"
  }, /*#__PURE__*/React.createElement("g", {
    id: "exterior-front-other-point",
    className: "svg-exterior-point"
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 536.027,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "exterior-front-other-text",
    x: 46,
    y: 558.118,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 536.027,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))));
};
export default SvgExteriorFrontOverlay;